import signUpServers from 'servers/sign-up-servers';

export const BASE_URL = signUpServers.getURLs().apiServer;
